/** A plugin's own view in a tab. */
import { useTranslation } from 'react-i18next';
import { PluginSurface } from './PluginSurface';
import { usePlugins } from './runtime';

export function PluginViewTab({ pluginId, viewId }: { pluginId: string; viewId: string }) {
  const { t } = useTranslation();
  const plugins = usePlugins();
  if (!plugins) return null;
  const plugin = plugins.find((p) => p.pageId === pluginId);
  const view = plugin?.manifest.views.find((v) => v.id === viewId);
  return (
    <div className="mx-auto w-full max-w-6xl px-6 py-6 sm:px-10" data-testid="plugin-view">
      {!plugin || !view || !plugin.enabled ? (
        <p className="text-sm text-fg-muted">{t('plugins.viewGone')}</p>
      ) : (
        <>
          <h1 className="mb-1 text-3xl font-bold">
            {view.icon ? `${view.icon} ` : ''}
            {view.title}
          </h1>
          <p className="mb-6 text-xs text-fg-muted">
            {t('plugins.from', { name: plugin.manifest.name })}
          </p>
          <PluginSurface plugin={plugin} kind="view" id={view.id} />
        </>
      )}
    </div>
  );
}
